import { render, staticRenderFns } from "./AdditionalPSPreCheck.vue?vue&type=template&id=47a42a53&scoped=true"
import script from "./AdditionalPSPreCheck.vue?vue&type=script&lang=js"
export * from "./AdditionalPSPreCheck.vue?vue&type=script&lang=js"
import style0 from "./AdditionalPSPreCheck.vue?vue&type=style&index=0&id=47a42a53&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a42a53",
  null
  
)

export default component.exports